import React, { forwardRef } from "react";
import { MigrationNudgeZone } from "../../layouts/MigrationNudgeLayout/MigrationNudgeLayout";
import { Content } from "./Content";
import { Divisions } from "./Divisions";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var MigrationNudge = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var CTAUrl = _ref.CTAUrl,
      onCTAClick = _ref.onCTAClick;
  return ___EmotionJSX(MigrationNudgeZone, {
    ref: ref
  }, ___EmotionJSX(Content, {
    CTAUrl: CTAUrl,
    onCTAClick: onCTAClick
  }), ___EmotionJSX(Divisions, null));
});
MigrationNudge.displayName = "MigrationNudge";